'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bomb';
var width = 512;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M32 304c0 97.2 78.8 176 176 176s176-78.8 176-176c0-21-3.7-41.1-10.4-59.7l-6.9-19.1 14.4-14.4L384 208l-80-80-2.9 2.9-14.4 14.4-19.1-6.9C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176zm32-8c0-75.1 60.9-136 136-136l8 0 0 32-8 0c-57.4 0-104 46.6-104 104l0 8-32 0 0-8z', 'M464 0l0 16 0 32 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32 16 0 32 0 0-32 0-16 32 0zM304 128l-2.9 2.9-14.4 14.4-19.1-6.9C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-21-3.7-41.1-10.4-59.7l-6.9-19.1 14.4-14.4L384 208l-80-80zM406.6 230.6l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9L304 82.7l22.6 22.6 28.7 28.7 17.4-17.4L384 105.4 406.6 128l-11.3 11.3-17.4 17.4 28.7 28.7L429.3 208l-22.6 22.6zM96 296l0 8-32 0 0-8c0-75.1 60.9-136 136-136l8 0 0 32-8 0c-57.4 0-104 46.6-104 104z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;